import React, { useEffect } from 'react'

import { 
    useFormContext, 
    useFieldArray,
    useWatch,
    Controller 
} from "react-hook-form"

import DatePicker from 'react-datepicker'

import { subYears } from 'date-fns'

import {
    ErrorText,
    RedTint
} from '../../../Styles/BaseStyles'

import { 
    SectionDiv, 
    HeaderDiv, 
    FormDiv, 
    SectionHeader, 
    ApplicationRowDiv,
    LeftApplicationDiv,
    RightApplicationDiv,
    ApplicationHeader,
    InputField,
    AddButtonDiv, 
    DeleteButtonDiv, 
    AddButton, 
    DeleteButton
} from  '../../../Styles/Components/ApplicationSectionStyles'

// Redux selector

import { useSelector } from "react-redux";

import '../../../Styles/CSS/react-datepicker-override.css'

function EducationSection(props) {
    const locked = useSelector(state => state.appViewer.locked)

    const { register, control, errors } = useFormContext()

    const { fields, append, remove } = useFieldArray({
        control,
        name: "education"
    })

    const educations = useWatch({
        control,
        name: 'education'
    })

    const educationTypes = [//info to use when switching to selector
        {value: 'Associate of Arts', label: 'Associate of Arts (A.A.)', level: 'Undergraduate'},
        {value: 'Associate of Science', label: 'Associate of Science (A.S.)', level: 'Undergraduate'},
        {value: 'Associate of Applied Science', label: 'Associate of Applied Science (A.A.S.)', level: 'Undergraduate'},
        {value: 'Bachelor of Arts', label: 'Bachelor of Arts (B.A.)', level: 'Undergraduate'},
        {value: 'Bachelor of Science', label: 'Bachelor of Science (B.S.)', level: 'Undergraduate'},
        {value: 'Bachelor of Fine Arts', label: 'Bachelor of Fine Arts (B.F.A.)', level: 'Undergraduate'},
        {value: 'Master of Arts', label: 'Master of Arts (M.A.)', level: 'Graduate'},
        {value: 'Master of Science', label: 'Master of Science (M.S.)', level: 'Graduate'},
        {value: 'Master of Business Administration', label: 'Master of Business Administration (MBA)', level: 'Graduate'},
        {value: 'Doctor of Philosophy', label: 'Doctor of Philosophy (Ph.D.)', level: 'Graduate'},
        {value: 'Doctor of Medicine', label: 'Doctor of Medicine (M.D.)', level: 'Graduate'},
        {value: 'Juris Doctor', label: 'Juris Doctor (J.D.)', level: 'Graduate'},
        {value: 'General Education', label: 'GED', level: 'High School'},
    ]

    return (
        <SectionDiv id = {props.name}>
            <HeaderDiv>
                <SectionHeader>Education</SectionHeader>
            </HeaderDiv>
            {fields.map((item, index) => {
                return (
                    <FormDiv className="education-form" key={item.id}>
                        <ApplicationRowDiv>
                            <LeftApplicationDiv>
                                <ApplicationHeader>School<RedTint>*</RedTint></ApplicationHeader>
                                <InputField 
                                    type="text" name={`education[${index}].school`} placeholder="School" 
                                    ref={
                                        register({
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            maxLength: {
                                                value: 200,
                                                message: 'exceeds 200 character limit'
                                            },
                                            pattern: {
                                                value: /^[a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð', -]+$/,
                                                message: 'invalid character used'
                                            }
                                        })
                                    } 
                                    defaultValue={item.school}
                                    readOnly={locked}
                                />
                                {errors['education'] != null && errors['education'][index] != null && errors['education'][index]['school'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['education'][index]['school']['message']}</ErrorText>}
                            </LeftApplicationDiv>
                            <RightApplicationDiv>
                                <ApplicationHeader>Education Degree/Type<RedTint>*</RedTint></ApplicationHeader>
                                <InputField 
                                    type="text" name={`education[${index}].degree`} placeholder="Education Degree/Type" 
                                    ref={
                                        register({
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            maxLength: {
                                                value: 30,
                                                message: 'exceeds 30 character limit'
                                            },
                                            pattern: {
                                                value: /^[a-zA-Z()\. ]+$/,
                                                message: 'invalid character usage'
                                            }
                                        })
                                    } 
                                    defaultValue={item.degree}
                                    readOnly={locked}
                                />
                                {errors['education'] != null && errors['education'][index] != null && errors['education'][index]['degree'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['education'][index]['degree']['message']}</ErrorText>}
                            </RightApplicationDiv>
                        </ApplicationRowDiv>
                        <ApplicationRowDiv>
                            <LeftApplicationDiv>
                                <ApplicationHeader>Concentration 1</ApplicationHeader>
                                <InputField 
                                    type="text" name={`education[${index}].concentration_1`} placeholder="Concentration 1" 
                                    ref={
                                        register({
                                            maxLength: {
                                                value: 60,
                                                message: 'exceeds 60 character limit'
                                            },
                                            pattern: {
                                                value: /^[a-zA-Z/ &:;,()-]+$/,
                                                message: 'invalid character used'
                                            }
                                        })
                                    } 
                                    defaultValue={item.concentration_1}
                                    readOnly={locked}
                                />
                                {errors['education'] != null && errors['education'][index] != null && errors['education'][index]['concentration_1'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['education'][index]['concentration_1']['message']}</ErrorText>}        
                            </LeftApplicationDiv>
                            <RightApplicationDiv>
                                <ApplicationHeader>Concentration 2</ApplicationHeader>
                                <InputField 
                                    type="text" name={`education[${index}].concentration_2`} placeholder="Concentration 2"
                                    ref={
                                        register({
                                            maxLength: {
                                                value: 60,
                                                message: 'exceeds 60 character limit'
                                            },
                                            pattern: {
                                                value: /^[a-zA-Z/ &:;,()-]+$/,
                                                message: 'invalid character used'
                                            }
                                        })
                                    }  
                                    defaultValue={item.concentration_2}
                                    readOnly={locked}
                                />
                                {errors['education'] != null && errors['education'][index] != null && errors['education'][index]['concentration_2'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['education'][index]['concentration_2']['message']}</ErrorText>}
                            </RightApplicationDiv>
                        </ApplicationRowDiv>
                        <ApplicationRowDiv>
                            <LeftApplicationDiv>
                                <ApplicationHeader>Graduation Date</ApplicationHeader>
                                <Controller
                                    as={
                                        <DatePicker 
                                            wrapperClassName="datePicker"
                                            dateFormat="MM/dd/yyyy"
                                            selected={
                                                typeof educations[index] !== 'undefined' && educations[index] !== null && educations[index]['graduation_date'] !== null && educations[index]['graduation_date'] !== '' ? new Date(educations[index]['graduation_date']) : null
                                            } 
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            customInput={<InputField />}
                                            placeholderText="MM/DD/YYYY"
                                            shouldCloseOnSelect
                                            popperPlacement="top"
                                            fixedHeight
                                            minDate={subYears(new Date(), 50)}
                                            maxDate={new Date()}
                                        />
                                    }
                                    errors={errors}
                                    control={control}
                                    register={
                                        register({ 
                                            
                                        })
                                    }
                                    name={`education[${index}].graduation_date`}
                                    defaultValue={
                                        (item.graduation_date !== null && typeof item.graduation_date !== 'object') ? new Date(item.graduation_date) : null
                                    }
                                    readOnly={locked}
                                />
                                {errors['education'] != null && errors['education'][index] != null && errors['education'][index]['graduation_date'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['education'][index]['graduation_date']['message']}</ErrorText>}
                            </LeftApplicationDiv>
                            <RightApplicationDiv>
                                <ApplicationHeader>GPA</ApplicationHeader>
                                <InputField 
                                    type="text" name={`education[${index}].GPA`} placeholder="GPA (i.e. X.XX)" 
                                    ref={
                                        register({
                                            maxLength: {
                                                value: 4,
                                                message: 'GPA exceeds 4 character limit'
                                            },
                                            pattern: {
                                                value: /^\d\.\d\d$/,
                                                message: 'invalid format or character usage'
                                            }
                                        })
                                    } 
                                    defaultValue={item.GPA}
                                    readOnly={locked}
                                />
                                {errors['education'] != null && errors['education'][index] != null && errors['education'][index]['GPA'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['education'][index]['GPA']['message']}</ErrorText>}
                            </RightApplicationDiv>
                        </ApplicationRowDiv>
                        {fields.length !== 0 && !locked ? 
                            <DeleteButtonDiv>
                                <DeleteButton type="button" onClick={() => remove(index)}>Delete</DeleteButton> 
                            </DeleteButtonDiv> : null
                        }
                    </FormDiv>
                );
            })}
            {!locked ?
                <AddButtonDiv>
                    <AddButton type="button" onClick={() => {append({school: "", degree: "", concentration_1: "", concentration_2: "", graduation_date: null, GPA: ""})}}>Add Education</AddButton>
                </AddButtonDiv> : null
            }
        </SectionDiv>
    )
}

export default EducationSection